import { WEB_API_URL } from '@config/env';
import { PROJECT_NAME, projects } from '@config/projects';

export const getCurrentProjectWebApiUrlById = (
  projectId: undefined | string
) => {
  if (!projectId) {
    return WEB_API_URL;
  }

  const currentProject = projects.find((project) => project.id === projectId);

  return currentProject?.webApiUrl ?? WEB_API_URL;
};

export const getCurrentProjectAdminApiUrlById = (
  projectId: undefined | string
) => {
  const currentProject = projects.find((project) => project.id === projectId);

  return currentProject?.adminApiUrl;
};

export const getProjectCurrencyName = (projectId: string) => {
  return projectId === PROJECT_NAME.FFD ? 'Coins' : 'Монет';
};

export const isFfdProject = (projectId?: string): boolean =>
  projectId === PROJECT_NAME.FFD;
